export const PATIENT_INACTIVATION_TYPE = Object.freeze({
  ACCESS_REVOKED: "ACCESS_REVOKED",
  RATE_LIMIT: "RATE_LIMIT",
});

export const PATIENT_STATUS = Object.freeze({
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
});
